import axios from 'axios';
import { put } from 'redux-saga/effects';

import { apiEndpoints } from '../../../config/config';
import { Creators } from './actions';

// *************************** Fetch Banner Saga ***************************
export function* fetchHomeBannerSaga(action) {
  try {
    yield put(Creators.fetchHomeBannerStart());
    const url = yield apiEndpoints.homePageBanner;
    const res = yield axios.get(url);
    // console.log('res: ', res);
    const bannerData = [];
    for (let key in res.data) {
      bannerData.push({
        id: key,
        ...res.data[key]
      });
    }
    // console.log('bannerData: ', bannerData);
    yield put(Creators.fetchHomeBannerSuccess(bannerData));
  } catch (err) {
    yield put(Creators.fetchHomeBannerFailure(err));
  }
}
// ______________________________________________________________________________

// *************************** Fetch Trending Saga ***************************
export function* fetchTrendingSaga(action) {
  try {
    yield put(Creators.fetchTrendingStart());
    const url = yield apiEndpoints.homeTrending;
    const res = yield axios.get(url);
    // console.log('res: ', res);
    const trending = [];
    if (res.data.success === 1) {
      for (let key in res.data.Top) {
        trending.push({
          id: key,
          ...res.data.Top[key]
        });
      }
    }
    yield put(Creators.fetchTrendingSuccess(trending));
  } catch (err) {
    yield put(Creators.fetchTrendingFailure(err));
  }
}
// ______________________________________________________________________________

// *************************** Fetch Latest Saga ***************************
export function* fetchLatestSaga(action) {
  // console.log('action: ', action);
  try {
    yield put(Creators.fetchLatestStart());
    let url;
    if (action.pageNumber === 1) {
      url = yield apiEndpoints.homeLatest;
    } else {
      url = yield `${apiEndpoints.homeLatest}/page/${action.pageNumber}`;
    }
    // console.log('url: ', url);
    const res = yield axios.get(url);
    // console.log('res: ', res);
    const latest = [];
    if (res.data.success === 0) {
      return;
    }
    if (res.status === 200) {
      for (let key in res.data) {
        latest.push({
          id: res.data[key].postId,
          ...res.data[key]
        });
      }
    }
    yield put(
      Creators.fetchLatestSuccess({
        pageNumber: action.pageNumber,
        latest,
        show: res.data.success === undefined ? 1 : 0
      })
    );
  } catch (err) {
    yield put(Creators.fetchLatestFailure(err));
  }
}
// ______________________________________________________________________________

// *************************** Fetch Reviews Saga ***************************
export function* fetchReviewsSaga(action) {
  try {
    yield put(Creators.fetchReviewsStart());
    const url = yield apiEndpoints.homeReviews;
    const res = yield axios.get(url);
    // console.log('res: ', res);
    const reviews = [];
    // if (res.data.success === 1) {
    if (res.status === 200) {
      for (let key in res.data) {
        reviews.push({
          id: key,
          ...res.data[key]
        });
      }
    }
    // console.log('reviews: ', reviews);
    yield put(Creators.fetchReviewsSuccess(reviews));
  } catch (err) {
    yield put(Creators.fetchReviewsFailure(err));
  }
}
// ______________________________________________________________________________
